import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=5ca08f58&scoped=true&"
import script from "./CommonFooter.vue?vue&type=script&lang=ts&"
export * from "./CommonFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=5ca08f58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca08f58",
  null
  
)

export default component.exports